import React from 'react'
import LogoContainer from '../components/LogoContainer'

const CerezPolitikasi = () => {
    return (
        <div className=' bg-white min-h-screen pb-20'>
       


            <div className='grid grid-cols-14 md:grid-cols-8'>

                <div className='col-start-2 col-span-12  md:col-start-2 md:col-span-6  '>
                <div >


       
                        <h1 className='text-35 font-medium mb-8'>ÇEREZ POLİTİKASI</h1>

                        <div>
                        <p className='text-20 mb-8'>
                        Gökdelen İskele-Kalıp Sanayi ve Ticaret A.Ş. olarak, web sitemizi ziyaret eden kullanıcılarımıza en iyi deneyimi sunmak ve hizmet kalitemizi artırmak amacıyla çerezler ve benzeri teknolojiler kullanmaktayız. Bu Çerez Politikası,{" "}
                            <a href="https://www.gokdelen.com.tr/" target="_blank" rel="noopener noreferrer">
                                https://www.gokdelen.com.tr/
                            </a>{" "}
                            adresli sitemizi ziyaret eden kullanıcılarımızın hangi kişisel verilerini
                            topladığımızı, bu verileri nasıl işlediğimizi ve koruduğumuzu açıklamaktadır.
                        </p>
                        </div>


    <div>
                        <h2 className='text-25 mb-4 font-medium'>1. Çerez Nedir?</h2>
                        <p className='mb-8'>Çerezler (cookies), web sitelerinin kullanıcı deneyimini geliştirmek ve belirli bilgileri saklamak amacıyla tarayıcılar aracılığıyla cihazınıza (bilgisayar, telefon, tablet vb.) yerleştirilen küçük metin dosyalarıdır. Çerezler, kullanıcı tercihlerini hatırlamak, oturum yönetimini sağlamak ve web sitesinin performansını analiz etmek için kullanılır.</p>
                        </div>






                        <div>
                        <h2 className='text-25 mb-4 font-medium'>2. Kullanılan Çerez Türleri ve Amaçları</h2>
                        <p className='mb-4'>Web sitemizde kullanılan çerezler aşağıdaki kategorilere ayrılmaktadır:</p>
                        <ul className='space-y-4 mb-8'>
                            <li>
                                <strong>Zorunlu Çerezler:</strong> Web sitesinin temel işlevlerini yerine getirebilmesi için gereklidir. Oturum yönetimi ve güvenlik amaçlarıyla kullanılır. Bu çerezler olmadan web sitesi düzgün çalışmayabilir.
                            </li>
                            <li>
                                <strong>Performans ve Analiz Çerezleri:</strong> Ziyaretçilerin web sitemizi nasıl kullandığını anlamamıza yardımcı olur. Hangi sayfaların ziyaret edildiği, ne kadar süre harcandığı gibi anonim verileri toplar ve analiz ederiz.
                            </li>
                            <li>
                                <strong>İşlevsellik Çerezleri:</strong> Kullanıcı tercihlerini hatırlayarak daha kişiselleştirilmiş bir deneyim sunmamızı sağlar. Örneğin, dil tercihinizin saklanmasını sağlar.
                            </li>
                            <li>
                                <strong>Hedefleme ve Reklam Çerezleri:</strong>  İlginizi çekebilecek içerik ve reklamları sunmak için kullanılır. Üçüncü taraf reklam ortakları tarafından da yerleştirilebilir.
                            </li>
                        </ul>
                        </div>

                        <div>
                        <h2 className='text-25 mb-4 font-medium'>3. Çerezlerin Saklanma Süresi</h2>
                        <p className='mb-4'>Çerezler, kullanım sürelerine göre ikiye ayrılır:</p>
                        <ul className='space-y-4 mb-8'>
                            <li>
                                <strong>Oturum Çerezleri:</strong> Tarayıcınızı kapattığınızda silinir.
                            </li>
                            <li>
                                <strong>Kalıcı Çerezler:</strong> Belirli bir süre boyunca cihazınızda saklanır veya siz manuel olarak silene kadar kalır.
                            </li>
                        </ul>
                        </div>





                        <div>
                        <h2 className='text-25 mb-4 font-medium'>4. Üçüncü Taraf Çerezleri</h2>
                        <p className='mb-8'>Web sitemiz, Google Analytics gibi üçüncü taraf hizmetleri kullanabilir. Bu hizmetler, site trafiğini analiz etmek veya reklamları kişiselleştirmek için çerezler yerleştirebilir. Üçüncü taraf çerezleri hakkında daha fazla bilgi almak için ilgili hizmet sağlayıcının politikalarını inceleyebilirsiniz.</p>
                        </div>


                        <div>
                        <h2 className='text-25 mb-4 font-medium'>5. Çerez Politikası Güncellemeleri</h2>
                        <p className='mb-8'>Bu Çerez Politikası, gerektiğinde güncellenebilir. Güncellemeler web sitemiz üzerinden duyurulacaktır. Çerez kullanımına ilişkin en güncel bilgilere her zaman bu sayfa üzerinden ulaşabilirsiniz.</p>
                        </div>











                        <div>
                        <h2 className='text-25 mb-4 font-medium'>6. İletişim</h2>
                        <p className='mb-4'>
                        Çerez Politikamız hakkında sorularınız veya talepleriniz için bizimle aşağıdaki iletişim bilgileri üzerinden iletişime geçebilirsiniz:
                        </p>
                        <p className='mb-2'>
                            <strong>Adres:</strong> Organize Sanayi Bölgesi 2. Kısım, İbrahim Çallı Cd. No.5,
                            20065 - DENİZLİ/TÜRKİYE
                        </p>
                        <p className='mb-2'>
                            <strong>Telefon:</strong>{" "}
                            <a href="tel:+902582691095">+90 (258) 269 10 95</a>
                        </p>
                        <p className='mb-2'>
                            <strong>E-posta:</strong>{" "}
                            <a href="mailto:info@gokdelen.com.tr">info@gokdelen.com.tr</a>
                        </p>

                        <p>
                        Bu Çerez Politikası, <strong>21 Şubat 2025</strong> tarihinde güncellenmiştir.
                        </p>
                        </div>




                        

                    </div>

                </div>
            </div>

        </div>
    )
}

export default CerezPolitikasi